import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { HttpErrorResponse } from '../../../node_modules/@angular/common/http';
import { RegisterActivity } from '../../app/models/RegisterActivity';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { TableService } from '../../services/table.service';
import { GenericQueryParams } from '../../utils/utils';
import { registerActivitiesTableConfig } from './registerActivitiesTableConfig';

/**
 * Generated class for the RegisterActivitiesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-register-activities',
  templateUrl: 'register-activities.html',
})
export class RegisterActivitiesPage implements OnInit {
  public currentActivityUuid: string = '';
  private pageName: string = 'page-register-activities';
  public tableHeaders = registerActivitiesTableConfig;

  private navControllerService: NavControllerService;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private storage: Storage,
    private translate: TranslateService,
    private app: App,
    public tableService: TableService
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.storage.get('registerActivity').then((activity: RegisterActivity) => {
      this.currentActivityUuid = activity ? activity.uuid : '';
    });
  }

  ngOnInit(): void {}

  print(activity: RegisterActivity) {
    this.backendService.getRegisterActivityPdf(activity.uuid).subscribe(
      (blob: Blob) => {
        const element = document.createElement('a');
        element.href = URL.createObjectURL(blob);
        element.download = activity.pos.name + ' ' + new Date().toDateString() + '.pdf';
        document.body.appendChild(element);
        element.click();
      },
      (err: HttpErrorResponse) => {}
    );
  }
  registerActivitiesQueryFn() {
    return (params: GenericQueryParams) => this.backendService.getRegisterActivities(params);
  }
  closeActivity(activity: RegisterActivity) {
    this.backendService.closeRegisterActivity(activity.uuid).subscribe(
      () => {
        this.tableService.refetch();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  showRegisterActivityDetails(registerActivityUuid) {
    this.navControllerService.showRegisterActivityDetails(registerActivityUuid);
  }

  showRegisterActivityTransactions(registerActivityUuid) {
    this.navControllerService.showRegisterActivityTransactions(registerActivityUuid);
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }
}



// WEBPACK FOOTER //
// ./src/pages/register-activities/register-activities.ts